import { render, staticRenderFns } from "./EmptyRouterTemplate.vue?vue&type=template&id=9844369a&"
import script from "./EmptyRouterTemplate.vue?vue&type=script&lang=ts&"
export * from "./EmptyRouterTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports